<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="requisitionDetails?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + requisitionDetails?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="requisitionDetails?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${requisitionDetails?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!requisitionDetails?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ requisitionDetails?.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ requisitionDetails?.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ requisitionDetails?.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ requisitionDetails?.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${requisitionDetails?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">PRODUCTION DELIVERY DETAILS</h2>
                      </div>
                    </td>
                  </tr>
                  

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td colspan="100%">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row>
                          <v-col cols="12">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;" class="table-borderd">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>Delivery Code</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ requisitionDetails?.code }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Delivery Date</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ requisitionDetails?.delivery_date }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Delivery Type</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ showRequisitionType(requisitionDetails?.type) }}</td>
                                </tr>
                                <tr v-if="requisitionDetails?.type == 'sale_order'">
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Sale Order No</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{requisitionDetails?.sale_order?.code }}</td>
                                </tr>
                                <tr v-if="requisitionDetails?.type == 'sale_order'">
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Production No</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{requisitionDetails?.production?.code }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Warehouse</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ requisitionDetails?.warehouse?.name }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Details table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table mt-5 table-borderd" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Code </th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Product</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Unit</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(item, index) in requisitionDetails?.details" :key="item.id">
                            <tr style="">
                              <td align="center">{{ item.product?.code }}</td>
                              <td >{{ item.product?.name }}</td>
                              <td align="center">{{ item.product?.unit?.name }}</td>
                              <td align="center">{{ item.quantity }}</td>
                            </tr>
                            <tr style="display: none;">
                              <td colspan="100%" class="pa-3">
                              

                                <!-- RAW MATERIAL TABLE -->
                                <table class="dep-table table-borderd">
                                  <thead>
                                    <tr>
                                      <th>Raw Product Code</th>
                                      <th>Raw Product</th>
                                      <th>Required Qty</th>
                                      <th>Loss %</th>
                                      <th>Total Qty</th>
                                      <th>Delivery Qty</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr v-for="row in item.raw_product_details" :key="row.id">
                                      <td  class="text-center">
                                        {{ row.raw_product?.code }}
                                      </td>
                                      <td  class="text-left">
                                        {{ row.raw_product?.name }}
                                      </td>
                                      <td class="text-center">
                                        {{ row.required_quantity }}
                                      </td>
                                      <td class="text-center">
                                        {{ row.process_loss_percent }}
                                      </td>
                                      <td class="text-center">
                                        {{ row.total_required_quantity }}
                                      </td>
                                      <td class="text-center">
                                        {{ row.delivery_qty }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <!-- <img v-if="requisitionDetails?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${requisitionDetails?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;"> -->
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" class="d-print-none mt-4 ">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import convertNumberToWords from "@/plugins/numberToWord";
import formattedDate from "@/plugins/dateFormatter";

const route = useRoute();
const router = useRouter();
const store = useStore();

const id = route.params.id;
const requisitionDetails = ref(null);
const invoiceHeader = ref(true);
const pagePadding = ref(0);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

const formattedAdvancePayment = computed(() => {
  if (!requisitionDetails.value) return '';
  const value = requisitionDetails.value.advance_payment_value || 0;
  const type = requisitionDetails.value.advance_payment_type;

  if (type === 'percentage' || type === 'percent') {
    return `${value}%`;
  } else if (type === 'flat') {
    return `${value}`;
  } else {
    return `${value} ${type}`;
  }
});

const requisitionType = [
  { value: "bulk", label: "Bulk" },
  { value: "sale_order", label: "Sale Order" },
];

function showRequisitionType(type) {
  return requisitionType.find((item) => item.value === type)?.label;
}

const formattedBalancePayment = computed(() => {
  if (!requisitionDetails.value) return '';
  const value = requisitionDetails.value.before_shipment_payment_value || 0;
  const type = requisitionDetails.value.before_shipment_payment_type;

  if (type === 'percentage' || type === 'percent') {
    return `${value}%`;
  } else if (type === 'flat') {
    return `${value}`;
  } else {
    return `${value} ${type}`;
  }
});

const formatNumber = (val) => {
  if (val == null || val === "") return "";
  return Number(val).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").outerHTML;

    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Production Delivery Details</title>

        <!-- Vuetify + Icons -->
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">

        <!-- IMPORTANT: Base Reset -->
        <style>
        
          body {
            margin: 0;
            padding: 0;
            
            font-family: sans-serif;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .page-header{
            padding-left: 18px;
          }

        

          .pa-3 {
            padding: 12px !important;
          }

          @page {
            size: A4;
            margin: ${pagePadding.value}px 10px;
          }

          .v-col{
            padding: 17px; 
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          .table-borderd th, .table-borderd td {
            border: 1px solid #000;
            font-size: 10px;
          }

          th {
            background: #e0e0e0 !important;
          }

          .report-paper {
            width: 100%;
          }

          .details-table {
            padding: 0 20px;
          }

          .text-center { text-align: center; }
          .text-left { text-align: left; }

          .d-flex {
            display: flex;
            justify-content: space-between;
          }

          .company-name {
            font-size: 12px;
            font-weight: bold;
          }

          .company-text {
            font-size: 10px;
          }

          .report-title {
            font-size: 16px;
            text-align: center;
            margin: 10px 0;
          }

          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            opacity: 0.1;
            z-index: 0;
          }

          tr {
            page-break-inside: avoid;
          }

          thead {
            display: table-header-group;
          }

        </style>
      </head>

      <body>
        ${printContent}
      </body>
      </html>
    `);

    printWindow.document.close();

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 500);

    // Reset
    invoiceHeader.value = true;
    pagePadding.value = 0;

  }, 300);
};

onMounted(async () => { 
  try {
    const res = await store.dispatch("getPrdDeliveryById", id);

    console.log(res);
    
    if (res?.success) {
      requisitionDetails.value = res.data;
      console.log("Master Sales Contact Data:", requisitionDetails.value);
    } else {
      console.error("API returned unsuccessful response:", res);
    }
  } catch (error) {
    console.error("Error fetching sales contact:", error);
  }
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 9px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
